<div class="container-fluid mt-3">
    <div class="card">
        <div class="card-header"><strong>{{ 'kaitoriya.master_management' | transloco }}</strong></div>
        <div class="card-body">
            <div class="row mb-2">
                <div class="col-md-3">
                    <wj-menu [(value)]="readonly" [header]="'kaitoriya.edit_mode' | transloco" [isDisabled]="masters.hasChanges()">
                        <wj-menu-item [value]="true">{{ 'kaitoriya.lock' | transloco }}</wj-menu-item>
                        <wj-menu-item [value]="false">{{ 'kaitoriya.editable' | transloco }}</wj-menu-item>
                    </wj-menu>
                    <span class="ml-2">{{ 'kaitoriya.hit_count' | transloco: {count: (masters.totalCount | number)} }}</span>
                </div>
            </div>
            <wj-flex-grid #masterGrid [itemsSource]="masters" [isReadOnly]="readonly"
                          [allowAddNew]="!readonly" [allowDelete]="!readonly" style="height:500px">
                <wj-flex-grid-filter></wj-flex-grid-filter>
                <wj-flex-grid-column [header]="'kaitoriya.category' | transloco" [binding]="'category'" [width]="150"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'kaitoriya.value' | transloco" [binding]="'value'" [width]="180"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'kaitoriya.color' | transloco" [binding]="'colorId'" [dataType]="'Number'" [width]="100"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'kaitoriya.weight' | transloco" [binding]="'weight'" [dataType]="'Number'" [width]="100"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'kaitoriya.sort_order' | transloco" [binding]="'sort'" [dataType]="'Number'" [width]="100"></wj-flex-grid-column>
            </wj-flex-grid>
        </div>
        <div class="card-footer">
            <div class="d-flex align-items-center flex-wrap">
                <wj-menu [(value)]="masters.pageSize" [header]="'kaitoriya.page_size' | transloco">
                    <wj-menu-item [value]="100">100</wj-menu-item>
                    <wj-menu-item [value]="500">500</wj-menu-item>
                    <wj-menu-item [value]="1000">1000</wj-menu-item>
                </wj-menu>
                <wj-collection-view-navigator class="ml-3" [cv]="masters"></wj-collection-view-navigator>
                <wj-collection-view-pager class="ml-3" [cv]="masters"></wj-collection-view-pager>
            </div>
            <div class="row mt-2" *ngIf="!readonly">
                <div class="col-md-3"><button [disabled]="!masters.hasChanges()" (click)="masters.saveChanges()" class="btn btn-primary btn-block">{{ 'kaitoriya.save_changes' | transloco }}</button></div>
                <div class="col-md-3"><button [disabled]="!masters.hasChanges()" (click)="masters.cancelChanges()" class="btn btn-secondary btn-block">{{ 'common.cancel' | transloco }}</button></div>
            </div>
        </div>
    </div>
</div>
